import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";


interface EvaluacionState {
    status: string;
    error: string;
    evaluacionList: any[];
    tipoEvaluacionList: any[];
    tipoPreguntaList: any[];
    evaluacion: {
        idEvaluacion: number | null;
        idModulo: number | null;
        nombre: string | null;
        idTipoEvaluacion: number | null;
        fechaInicio: Date | null;
        fechaVencimiento: Date | null;
        mensajeInicial: string | null;
        mensajeFinal: string | null;
        creditos: number | null;
        idReferencia: number | null;
        idTipoReferencia: number | null;
        editable?: boolean | null;
    }
}

const initialState: EvaluacionState = {
    status: "idle",
    error: "",
    evaluacionList: [],
    tipoEvaluacionList: [],
    tipoPreguntaList: [],
    evaluacion: {
        idEvaluacion: null,
        idModulo: null,
        nombre: null,
        idTipoEvaluacion: null,
        fechaInicio: null,
        fechaVencimiento: null,
        mensajeInicial: null,
        mensajeFinal: null,
        creditos: null,
        idReferencia: null,
        idTipoReferencia: null,
        editable: null,
    }
}

export const fetchEvaluacion = createAsyncThunk('fetchEvaluacion', async ({ idModulo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 89;
    const { result, message, data } = await getData({ idsp, idModulo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchEncuesta = createAsyncThunk('fetchEncuesta', async ({ idReferencia, idTipoReferencia }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 102;
    const { result, message, data } = await getData({ idsp, idReferencia, idTipoReferencia }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchTipoEvaluacion = createAsyncThunk('fetchTipoEvaluacion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 90;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchTipoPregunta = createAsyncThunk('fetchTipoPregunta', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 91;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const createModifyEvaluacion = createAsyncThunk('createModifyEvaluacion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const evaluacionNew = selectEvaluacion(state);
    const evaluacionAttributes = {
        idEvaluacion: evaluacionNew.idEvaluacion,
        idModulo: evaluacionNew.idModulo,
        nombre: evaluacionNew.nombre,
        idTipoEvaluacion: evaluacionNew.idTipoEvaluacion,
        fechaInicio: evaluacionNew.fechaInicio,
        fechaVencimiento: evaluacionNew.fechaVencimiento,
        mensajeInicial: evaluacionNew.mensajeInicial,
        mensajeFinal: evaluacionNew.mensajeFinal,
        creditos: evaluacionNew.creditos,
        idReferencia: evaluacionNew.idReferencia,
        idTipoReferencia: evaluacionNew.idTipoReferencia,
    };
    const idsp = evaluacionAttributes.idEvaluacion ? 87 : 86;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...evaluacionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchEvaluacion({ idModulo: evaluacionAttributes.idModulo }));
    return rejectWithValue(message);
});

export const createModifyEncuesta = createAsyncThunk('createModifyEncuesta', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const evaluacionNew = selectEvaluacion(state);
    const evaluacionAttributes = { ...evaluacionNew };
    const idsp = evaluacionAttributes.idEvaluacion ? 101 : 100;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...evaluacionAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchEvaluacion({ idModulo: evaluacionAttributes.idModulo }));
    return rejectWithValue(message);
});


export const deleteEvaluacion = createAsyncThunk('deleteEvaluacion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const evaluacionNew = selectEvaluacion(state);
    const evaluacionAttributes = { ...evaluacionNew }
    const idEvaluacion = evaluacionAttributes.idEvaluacion;
    const idsp = 88;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idEvaluacion }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisibleSecondary(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    return rejectWithValue(message);
});

export const evaluacionSlice = createSlice({
    name: 'evaluacion',
    initialState,
    reducers: {
        setEvaluacion: (state, action) => {
            state.evaluacion = !action.payload ? initialState.evaluacion : action.payload;
        },
        setEvaluacionList: (state, action) => {
            state.evaluacionList = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchEvaluacion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchEvaluacion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.evaluacionList = data ? data : [];

            })
            .addCase(fetchEvaluacion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchEncuesta.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchEncuesta.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.evaluacionList = data ? data : [];

            })
            .addCase(fetchEncuesta.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchTipoEvaluacion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTipoEvaluacion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.tipoEvaluacionList = data ? data : [];

            })
            .addCase(fetchTipoEvaluacion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchTipoPregunta.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTipoPregunta.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.tipoPreguntaList = data ? data : [];

            })
            .addCase(fetchTipoPregunta.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })

    }
})

export const selectEvaluacion = (state: RootState) => state.evaluacion.evaluacion;
export const selectEvaluacionList = (state: RootState) => state.evaluacion.evaluacionList;
export const selectTipoEvaluacionList = (state: RootState) => state.evaluacion.tipoEvaluacionList;
export const selectTipoPreguntaList = (state: RootState) => state.evaluacion.tipoPreguntaList;

export const { setEvaluacion, setEvaluacionList } = evaluacionSlice.actions;

export default evaluacionSlice.reducer;
